/**
 * Default pitch-pin positions (percent of map-image width/height) for the
 * interactive pitch map. Positions are read from Justina's official site plan
 * (LBWL 001 — both lakes, Dec/25): Walnut Lake hardstanding 1–5 in the row on
 * the lake's south bank (ids walnut-hs-11…15), Daisy Lake hardstanding 1–10
 * around the east/north banks, Grass EHU 1–12 up the east side, Tent 1–20 in
 * the back field (T1–T15 exactly as marked, T16–T17 continuing the top row,
 * T18–T20 continuing down the west side). Lodges are estimated on Daisy
 * Lake's west bank — drag to exact buildings in Admin → Pitch Media.
 * Saved positions in site content (pitchmap.map.positions) override these.
 *
 * Coordinates: x = % from left, y = % from top.
 */
export const DEFAULT_PITCH_POSITIONS = {
  // Daisy Lake — hardstanding 1–10 (east bank 1–8 bottom→top, 9–10 at the north end)
  "daisy-hs-01": { x: 63.7, y: 63.8 },
  "daisy-hs-02": { x: 63.7, y: 60.9 },
  "daisy-hs-03": { x: 62.8, y: 56.6 },
  "daisy-hs-04": { x: 62.4, y: 52.7 },
  "daisy-hs-05": { x: 60.6, y: 49.3 },
  "daisy-hs-06": { x: 58.4, y: 46.5 },
  "daisy-hs-07": { x: 60.2, y: 41.9 },
  "daisy-hs-08": { x: 58.4, y: 39.0 },
  "daisy-hs-09": { x: 46.9, y: 46.5 },
  "daisy-hs-10": { x: 42.7, y: 46.9 },
  // Walnut Lake — hardstanding 1–5 (guest-facing numbers; ids 11–15)
  "walnut-hs-11": { x: 24.9, y: 37.5 },
  "walnut-hs-12": { x: 31.1, y: 37.5 },
  "walnut-hs-13": { x: 36.0, y: 37.3 },
  "walnut-hs-14": { x: 41.3, y: 36.8 },
  "walnut-hs-15": { x: 46.5, y: 33.2 },
  // Grass with electric Gr 1–12 — up the east side (Gr 1 lowest)
  "walnut-grass-01": { x: 61.5, y: 34.7 },
  "walnut-grass-02": { x: 61.5, y: 33.2 },
  "walnut-grass-03": { x: 61.5, y: 31.6 },
  "walnut-grass-04": { x: 60.8, y: 30.0 },
  "walnut-grass-05": { x: 60.8, y: 28.4 },
  "walnut-grass-06": { x: 60.2, y: 26.2 },
  "walnut-grass-07": { x: 59.4, y: 24.2 },
  "walnut-grass-08": { x: 58.9, y: 22.1 },
  "walnut-grass-09": { x: 58.8, y: 19.7 },
  "walnut-grass-10": { x: 59.1, y: 17.0 },
  "walnut-grass-11": { x: 57.5, y: 14.3 },
  "walnut-grass-12": { x: 57.2, y: 11.4 },
  // Tent field — T1–T9 west column, T10–T17 top row, T18–T20 down the west side
  "walnut-tent-01": { x: 15.6, y: 28.0 },
  "walnut-tent-02": { x: 15.6, y: 26.3 },
  "walnut-tent-03": { x: 15.3, y: 24.6 },
  "walnut-tent-04": { x: 15.2, y: 22.5 },
  "walnut-tent-05": { x: 14.8, y: 20.5 },
  "walnut-tent-06": { x: 14.8, y: 17.8 },
  "walnut-tent-07": { x: 12.9, y: 15.6 },
  "walnut-tent-08": { x: 13.1, y: 13.2 },
  "walnut-tent-09": { x: 12.2, y: 11.3 },
  "walnut-tent-10": { x: 17.5, y: 9.4 },
  "walnut-tent-11": { x: 23.1, y: 9.4 },
  "walnut-tent-12": { x: 28.1, y: 9.4 },
  "walnut-tent-13": { x: 34.8, y: 9.4 },
  "walnut-tent-14": { x: 40.4, y: 9.5 },
  "walnut-tent-15": { x: 45.3, y: 9.5 },
  "walnut-tent-16": { x: 50.9, y: 9.6 },
  "walnut-tent-17": { x: 56.5, y: 9.8 },
  "walnut-tent-18": { x: 15.9, y: 30.1 },
  "walnut-tent-19": { x: 16.2, y: 32.2 },
  "walnut-tent-20": { x: 16.5, y: 34.3 },
  // Lodges — per Justina's labelled photo: Alpine is the long lodge between the
  // lakes; Heron & Kingfisher are the two cabins by the entrance courtyard.
  "lodge-alpine": { x: 31.5, y: 45.4 },
  "lodge-heron": { x: 44.5, y: 78.0 },
  "lodge-kingfisher": { x: 48.5, y: 79.8 },
};

/** Click-to-zoom zones for the two lakes (percent boxes over the site plan). */
export const LAKE_ZONES = {
  "Daisy Lake": { left: 26, top: 42, width: 42, height: 34, origin: "46% 59%" },
  "Walnut Lake": { left: 18, top: 18, width: 38, height: 24, origin: "37% 30%" },
};
